import { ArrowRight, Calendar, Tag } from "lucide-react";
import { Card, CardContent, CardFooter, CardHeader } from "./ui/card";
import { Blog } from "@/types/supabase";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";

const BlogCard = ({ post, index }: { post: Blog; index: number }) => {
  return (
    <Card
      key={post.id}
      className="glass-morphism border-0 overflow-hidden animate-fade-in group cursor-pointer transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl hover:shadow-teal/20 hover:border hover:border-teal/30"
      style={{ animationDelay: `${0.2 + index * 0.1}s` }}
    >
      <Link to={`/blogs/${post.id}`} className="relative h-48 overflow-hidden block">
        <img
          src={post.image_url}
          alt={post.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          width="400"
          height="192"
          loading="lazy"
        />
      </Link>

      <CardHeader className="p-5 pb-0">
        <div className="flex flex-wrap gap-2 mb-3 items-center">
          {post.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="text-xs bg-white/10 text-gray-300 px-2 py-1 rounded-full flex items-center"
            >
              <Tag className="h-3 w-3 mr-1" />
              {tag}
            </span>
          ))}
          {post.tags.length > 3 && (
            <span className="text-xs text-gray-400">
              +{post.tags.length - 3} similar
            </span>
          )}
        </div>

        <Link to={`/blogs/${post.id}`}>
          <h2 className="text-xl font-semibold text-white mb-2 transition-colors duration-300 group-hover:text-teal">{post.title}</h2>
        </Link>
      </CardHeader>

      <CardContent className="p-5">
        <p className="text-gray-400 line-clamp-3 text-sm mb-4">
          {post.excerpt}
        </p>

        
      </CardContent>

      <CardFooter className="p-5 pt-0 flex items-center justify-between gap-3 flex-wrap min-w-0">
        <div className="flex items-center text-sm text-gray-400">
          <Calendar className="h-4 w-4 mr-1" />
          <span>
            {new Date(post.date).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </span>
        </div>

        <Button
          variant="ghost"
          size="sm"
          className="text-teal hover:bg-teal/10 max-w-full min-w-0 transition-all duration-300 group-hover:translate-x-1"
          asChild
        >
          <Link
            to={`/blogs/${post.id}`}
            aria-label={`Read blog post: ${post.title}`}
            className="inline-flex items-center gap-1 overflow-hidden whitespace-nowrap text-ellipsis min-w-0"
            title={post.title}
          >
            <span className="overflow-hidden whitespace-nowrap text-ellipsis">Read post</span>
            <span className="sr-only">: {post.title}</span>
            <ArrowRight className="ml-2 h-3 w-3 flex-none" />
          </Link>
        </Button>
      </CardFooter>
    </Card>
  );
};

export default BlogCard;
